(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jaira-reservation-choice"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';
    const dialog = document.getElementById('JairaReservationChoice');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let trigger = null;
    function isReservationTrigger(element) {
      if (!element || !element.closest('header, nav, #SiteNav, #MobileNav')) return false;
      return element.textContent.trim().toLocaleLowerCase('es') === 'reservas';
    }
    document.querySelectorAll('header a, header button, nav a, nav button').forEach(element => {
      if (isReservationTrigger(element)) {
        element.setAttribute('aria-haspopup', 'dialog');
        element.setAttribute('aria-controls', dialog.id);
      }
    });
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target.closest('a, button') : null;
      if (!isReservationTrigger(target) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      trigger = target;
      if (!dialog.open) dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('jaira-reservation-choice-open');
      dialog.querySelector('.jaira-reservation-choice__option').focus();
    }, true);
    dialog.querySelectorAll('[data-jaira-reservation-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('jaira-reservation-choice-open');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
